import { Component, inject, signal } from '@angular/core';
import { LoginFacade } from '../../../state/login.facade';
import { ConfigService } from '../../../../services/config.service';

@Component({
  selector: 'app-guest',
  templateUrl: './guest.component.html',
  styleUrls: ['./guest.component.scss']
})
export class GuestComponent {
  private readonly loginFacade = inject(LoginFacade);
  private readonly configService = inject(ConfigService);

  readonly customMessage = signal<string>(this.configService.get().loginMessage);
  readonly customLoginUrl = signal<string>(this.configService.get().customLoginUrl);

  loadLogin(event: MouseEvent) {
    event.preventDefault();
    this.loginFacade.changeScreen('login');
  }

  login() {
    this.loginFacade.externalLogin(this.customLoginUrl());
  }
}
